import { Box } from "@chakra-ui/react";

export default function Line({ height = "24px", ...rest }) {
  return <Box bg="outline" w="2px" height={height} {...rest} />;
}
